/**
 * Custom JS
 */

import { linkCard } from "./cards.js";
import { accordion } from "./accordion.js";
import { callBackTempsFort } from "./tiny-slider.js";
import { initOrejimeInstance } from "./orejime/orejime.js";

linkCard();
accordion();
callBackTempsFort();

document.addEventListener("DOMContentLoaded", function() {
    initOrejimeInstance();
    const dropdownButton = document.querySelector("#dropdownMenu2");
    const menu = document.querySelector("#menu-secondaire");
    
    const isMobile = window.innerWidth <= 1024;
    
    const toggleMenu = () => {
      menu.classList.toggle("collapse");
    };
  
    if (dropdownButton && isMobile) {
      dropdownButton.addEventListener("click", toggleMenu);
    }

    window.addEventListener("resize", function () {
      const isMobile = window.innerWidth <= 1024;
      
      if (!isMobile) {
        menu.classList.remove("collapse");
      }
    });

  });

$(document).on('click', '.heading-accordion', function() {
    const ariaExpanded = $(this).attr('aria-expanded') === 'true' || false;

    let text = $(this).attr('data-text');
    $(this).attr('data-text', $(this).text());
    $(this).text(text);

    $(this).attr('aria-expanded', !ariaExpanded);
    $(this).siblings('.accordion-panel').toggleClass('open');
    $(this).siblings('.accordion-panel').find('a:first-child').focus();
});
